import React, { useContext, useEffect, useState } from "react";
import Header from "../header/Header";
import Body from "../body/Body";
import Footer from "../footer/Footer";

import Utils from "../Utils";
import ContextComponent from "../AppContext";
import { useLocation, useNavigate } from "react-router-dom";

const LandingPage = () => {
  let [canRender, setCanRender] = useState(false);
  let { userData, virtualFolderData  } = useContext(ContextComponent);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!Utils.isObjectEmpty(userData)) {
      setCanRender(true);
    } 
  }, [userData]);

  useEffect(() => {
    const rootPaths = [
      "/internal",
      "/internal/",
      "/internal/sites",
      "/internal/project",
      "/internal/project/",
    ];

    if (
      virtualFolderData.length > 0 &&
      rootPaths.includes(location.pathname)
    ) {
      const rootNode = virtualFolderData.find((node) => node.parentId === null);
      if (rootNode) {
        navigate(`/internal/project/${rootNode.id}`, { replace: true });
      } 
    } 
  }, [virtualFolderData, location.pathname, navigate]);

  return (
    <>
      <Header />
      {canRender && (<>
        <Body />
        <Footer />
      </>)}
    </>
  )
};

export default LandingPage;
